import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../lib/auth";
import Logo from "../components/Logo";

export default function MemberLoginPage() {
  const nav = useNavigate();
  const { login, registerMember } = useAuth();
  const [mode, setMode] = useState("login");
  const [form, setForm] = useState({ email: "", password: "", first_name: "", last_name: "", phone: "", city: "", country: "France", function: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      if (mode === "login") {
        await login(form.email, form.password);
        toast.success("Bienvenue !");
        nav("/membres");
      } else {
        await registerMember(form);
        toast.success("Compte créé.");
        nav("/membres");
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2" data-testid="member-login-page">
      <div className="hidden lg:block bg-ink text-white p-12 relative overflow-hidden grain">
        <Logo className="w-20 h-20 mb-8" />
        <div className="eyebrow eyebrow-on-dark">Espace membres</div>
        <h1 className="font-serif text-4xl mt-4 leading-tight">Connectez-vous à la <span className="text-gold italic font-light">communauté du Front Uni.</span></h1>
        <p className="mt-6 text-white/75 max-w-md">Profil, messagerie interne, conférences privées, publications : tout l'écosystème de la diaspora.</p>
        <div className="divider-gold w-24 mt-10" />
        <div className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full bg-gold/10 blur-3xl" />
      </div>
      <div className="grid place-items-center bg-bone p-8 lg:p-16">
        <div className="w-full max-w-md">
          <div className="flex gap-1 mb-8 border border-border rounded-sm bg-white p-1">
            <button onClick={() => setMode("login")} data-testid="tab-login"
                    className={`flex-1 py-2.5 text-sm font-semibold rounded-sm transition-colors ${mode === "login" ? "bg-ink text-white" : "text-foreground/60"}`}>
              <LogIn className="w-4 h-4 inline mr-2" /> Connexion
            </button>
            <button onClick={() => setMode("register")} data-testid="tab-register"
                    className={`flex-1 py-2.5 text-sm font-semibold rounded-sm transition-colors ${mode === "register" ? "bg-ink text-white" : "text-foreground/60"}`}>
              <UserPlus className="w-4 h-4 inline mr-2" /> Inscription
            </button>
          </div>
          <form onSubmit={submit} className="bg-white border border-border rounded-sm p-8 space-y-4">
            {mode === "register" && (
              <div className="grid grid-cols-2 gap-3">
                <Field label="Prénom" v={form.first_name} on={(v) => setForm({ ...form, first_name: v })} test="reg-first" />
                <Field label="Nom" v={form.last_name} on={(v) => setForm({ ...form, last_name: v })} test="reg-last" />
              </div>
            )}
            <Field label="Email" type="email" v={form.email} on={(v) => setForm({ ...form, email: v })} test="login-email" />
            <Field label="Mot de passe" type="password" v={form.password} on={(v) => setForm({ ...form, password: v })} test="login-password" />
            {mode === "register" && (
              <div className="grid grid-cols-2 gap-3">
                <Field label="Ville" v={form.city} on={(v) => setForm({ ...form, city: v })} test="reg-city" />
                <Field label="Pays" v={form.country} on={(v) => setForm({ ...form, country: v })} test="reg-country" />
              </div>
            )}
            <button disabled={loading} type="submit" className="btn-primary w-full justify-center mt-2" data-testid="login-submit">
              {loading ? "…" : mode === "login" ? "Se connecter" : "Créer mon compte"}
            </button>
          </form>
          <div className="mt-6 text-center text-sm text-foreground/60">
            <Link to="/" className="hover:text-ink">← Retour au site</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, v, on, type = "text", test }) {
  return (
    <div>
      <label className="block text-[0.7rem] uppercase tracking-[0.16em] font-semibold text-foreground/60 mb-2">{label}</label>
      <input required type={type} value={v} onChange={(e) => on(e.target.value)}
             className="w-full border border-border rounded-sm p-3 text-sm focus:border-ink outline-none" data-testid={test} />
    </div>
  );
}
